import Triangles from '@/assets/icons/triangles.svg'
import { fadeUp } from '@/core/constants/animations'
import { cn } from '@/core/lib/utils/cn'
import { Motion } from '@/core/ui/atoms/motion'

type Props = {
  title: string
  content: string
  image: React.ReactNode
  className?: string
}

export const LegalInfo: React.FC<Props> = ({
  title,
  content,
  image,
  className = '',
}) => {
  return (
    <Motion
      type='section'
      className={cn('relative mt-10 mb-16', className)}
      initial='initial'
      animate='animate'
      variants={fadeUp.variants}
      transition={fadeUp.transition}
      aria-labelledby='privacy-policy-heading'
    >
      <div className='mb-8 flex justify-between'>
        <h1 id='privacy-policy-heading' className='text-3xl font-medium'>
          {title}
        </h1>
        <Triangles className='absolute top-8 -right-4 block sm:top-0 sm:right-0 sm:h-24 sm:w-36 md:right-10 lg:hidden' />
      </div>

      <div className='grid lg:grid-cols-3 lg:gap-16'>
        <article className='prose col-span-2 max-w-none'>
          <div dangerouslySetInnerHTML={{ __html: content }} />
        </article>

        <figure className='mt-20 hidden lg:col-span-1 lg:block'>{image}</figure>
      </div>
    </Motion>
  )
}
